<template>
    <div>
        <div class="card">
            <div class="card-header">My Profile</div>
            <!-- <h1 class="display-heading">My Profile</h1> -->
            <div class="card-body">
                <div class="mb-3">
                    <user-profile-common ref="userProfileForm" v-model="userProfile"></user-profile-common>
                    <user-profile-specific ref="userProfileSpecificForm" v-model="userProfileSpecific"></user-profile-specific>
                </div>

                <div class="form-row">
                    <div class="form-group">
                        <div class="mb-2 small text-danger">
                            * Required fields.
                        </div>
                    </div>
                </div>

                <p v-show="isSubmitMessageShown" :class="{
                    'text-danger': isSubmitMessageError
                }">
                    {{submitMessage}}
                </p>

                <button type="button" class="btn btn-primary btn-primary-insv mr-2" @click="saveProfile">
                    Save Changes
                </button>
                <button type="button" class="btn btn-secondary" @click="getProfile">Cancel Changes</button>
            </div>
        </div>

        <div v-if="isNormalUser" class="mt-5">
            <data-access-permissions></data-access-permissions>
            <!-- <div class="card">
                <div class="card-header">Data Access Permissions</div>
                <div class="card-body">
                    <div class="mb-3">
                    <p>Allow Doctors to Access All My Past Consultations Data</p>
                    <div class="mb-3">
                        <toggle-button :checkboxValue.sync="consent.pastConsultation"
                            @update:checkboxValue="updateConsentConsultations">
                        </toggle-button>
                        &nbsp;&nbsp;{{ consent.pastConsultation ? "Allowed" : "Disallowed" }}
                    </div>
                    <p>Last Updated: {{ consent.pastConsultationLastUpdated ? consent.pastConsultationLastUpdated : "NIL" }}</p>
                    </div>
                    <hr>
                    <div>
                    <p>Allow Doctors to Access All My Medical Reports</p>
                    <div class="mb-3">
                        <toggle-button :checkboxValue.sync="consent.medicalReports"
                            @update:checkboxValue="updateConsentMedicalReports">
                        </toggle-button>
                        &nbsp;&nbsp;{{ consent.medicalReports ? "Allowed" : "Disallowed" }}
                    </div>
                    <p>Last Updated: {{ consent.medicalReportsLastUpdated ? consent.medicalReportsLastUpdated : "NIL" }}</p>
                    </div>
                </div>
            </div> -->
            <br/>
            <profile-verification ref="profile-verification"></profile-verification>
            <br/>
            <guardian-permission v-if="kycStatus == 2" ref="medical-record-sharing-consent"></guardian-permission>
        </div>

        <!-- <popup-modal ref="popupUpdateSuccessful" :hasCloseButton="false" title="Permission Update">
            <template slot="content">
                <p>{{consent.submitMessage}}</p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupSuccessful">Okay</button>
            </template>
        </popup-modal> -->

        <popup-modal ref="popupCompleteProfile" :hasCloseButton="false" title="Complete your Profile">
            <template slot="content">
                <p>Please complete your profile before proceeding with other actions.</p>
                <p>Thank you.</p>
            </template>
            <template slot="footer">
                <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupCompleteProfile">Okay</button>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import { convertDateToDDMMYYYY, convertDateToIso8601 } from '@/utilities';
import userProfileCommon from '@/components/user-profile';
import userProfileSpecific from '@/components/user-profile/user';
import dataAccessPermissions from '@/components/data-access-permissions';
import changePassword from '@/components/change-password';
import toggleButton from '@/components/toggle-button';
import popupModal from '@/components/popup-modal';
import guardianPermission from '@/components/guardian-permission';
import profileVerification from '@/components/profile-verification';
export default {
    'name': 'DoctorProfile',
    'components': {
        userProfileCommon,
        userProfileSpecific,
        changePassword,
        toggleButton,
        popupModal,
        dataAccessPermissions,
        guardianPermission,
        profileVerification
    },
    'computed': {
        isNormalUser () {
            return this.$store.state.user.userRole === 1;
        }
    },
    'data': function () {
        return {
            'userProfile': {
                'designation': null,
                'designationChoice': 'Mr.',
                'name': null,
                'gender': 0,
                'birthDate': null,
                'email': null,
                'phoneNo': null,
                'identitifcationType': 0,
                'identificationNumber': null
            },
            'userProfileSpecific': {
                'addressLine1': null,
                'addressLine2': null,
                'addressCity': null,
                'addressState': null,
                'addressPostcode': null,
                'mailingAddressLine1': null,
                'mailingAddressLine2': null,
                'mailingAddressCity': null,
                'mailingAddressState': null,
                'mailingAddressPostcode': null
            },
            'isSubmitMessageShown': false,
            'isSubmitMessageError': false,
            'submitMessage': '',
            'consent': {
                'pastConsultation': false,
                'pastConsultationLastUpdated': null,
                'medicalReports': false,
                'medicalReportsLastUpdated': null,
                'submitMessage': null
            },
            'hash': this.$route.hash,
            'kycStatus': 2
        };
    },
    mounted () {
        this.getProfile();
        // this.getConsentConsultations();
        // this.getConsentMedicalReports();
        this.getKycStatus();

        this.$nextTick(() => {
            if (this.$store.state.user.isProfileCompleted === 0) {
                this.$refs.popupCompleteProfile.show();
            }
            if (this.hash) {
                const refName = this.hash.replace('#', '');
                this.scrollToAnchorPoint(refName);
            }
        });
    },
    'methods': {
        getProfile () {
            this.isSubmitMessageShown = false;
            this.$refs.userProfileForm.clearValidation();

            this.axios.get('Profile/GetUserProfile').then(({ data }) => {
                let profileData = data.data;
                this.userProfile.name = profileData.f;
                this.userProfile.designationChoice = profileData.d;
                this.userProfile.email = profileData.e;
                this.userProfile.identitifcationType = profileData.ict;
                this.userProfile.identificationNumber = profileData.ic;
                this.userProfile.birthDate = convertDateToDDMMYYYY(profileData.bd);
                this.userProfile.gender = profileData.g;
                this.userProfile.phoneNo = profileData.p;

                let userProfileSpecific = profileData.up;
                this.userProfileSpecific.addressLine1 = userProfileSpecific.al1;
                this.userProfileSpecific.addressLine2 = userProfileSpecific.al2;
                this.userProfileSpecific.addressCity = userProfileSpecific.ac;
                this.userProfileSpecific.addressState = userProfileSpecific.as;
                this.userProfileSpecific.addressPostcode = userProfileSpecific.ap;
                this.userProfileSpecific.mailingAddressLine1 = userProfileSpecific.mal1;
                this.userProfileSpecific.mailingAddressLine2 = userProfileSpecific.mal2;
                this.userProfileSpecific.mailingAddressCity = userProfileSpecific.mac;
                this.userProfileSpecific.mailingAddressState = userProfileSpecific.mas;
                this.userProfileSpecific.mailingAddressPostcode = userProfileSpecific.map;
            }).catch((ex) => {
            });
        },
        saveProfile () {
            this.isSubmitMessageShown = true;
            this.isSubmitMessageError = false;
            Promise.all([this.$refs.userProfileForm.validateForm(), this.$refs.userProfileSpecificForm.validateForm()]).then(
                (validationResults) => {
                    this.$nextTick(() => {
                        if (validationResults.filter(v => v === false).length > 0) {
                        // focus to the first error
                            document.body.querySelector('.is-invalid').focus();

                            this.isSubmitMessageError = true;
                            this.submitMessage = 'You have error in the form. Please check your input(s) before saving your profile.';
                        } else {
                            this.submitMessage = 'Saving profile...';
                            if (this.userProfile.designationChoice !== -1) {
                                this.userProfile.designation = this.userProfile.designationChoice;
                            }
                            this.axios.post('Profile/UpdateUserProfile', {
                                'f': this.userProfile.name,
                                'd': this.userProfile.designation,
                                'e': this.userProfile.email,
                                'ict': this.userProfile.identitifcationType,
                                'ic': this.userProfile.identificationNumber,
                                'bd': convertDateToIso8601(this.userProfile.birthDate),
                                'g': this.userProfile.gender,
                                'p': this.userProfile.phoneNo,

                                'up': {
                                    'al1': this.userProfileSpecific.addressLine1,
                                    'al2': this.userProfileSpecific.addressLine2,
                                    'ac': this.userProfileSpecific.addressCity,
                                    'as': this.userProfileSpecific.addressState,
                                    'ap': this.userProfileSpecific.addressPostcode,
                                    'mal1': this.userProfileSpecific.mailingAddressLine1,
                                    'mal2': this.userProfileSpecific.mailingAddressLine2,
                                    'mac': this.userProfileSpecific.mailingAddressCity,
                                    'mas': this.userProfileSpecific.mailingAddressState,
                                    'map': this.userProfileSpecific.mailingAddressPostcode
                                }
                            }).then(() => {
                                this.submitMessage = 'Successfully updated profile! Your information is saved and encrypted.';
                                this.$store.commit('completedProfile');
                            }).catch((error) => {
                                this.isSubmitMessageError = true;
                                if (error.response.data) {
                                    this.submitMessage = 'Please provide required info!';
                                } else {
                                    this.submitMessage = 'Error saving profile. Please try again.';
                                }
                            });
                        }
                    });
                });
        },
        // getConsentConsultations () {
        //     this.axios.get('Profile/GetConsent', {
        //         'params': {
        //             'consentType': 1001
        //         }
        //     }).then(({ data }) => {
        //         if (data.data) {
        //             this.consent.pastConsultation = data.data.ia;
        //             this.consent.pastConsultationLastUpdated = data.data.aa ? convertToUserReadableDateTime(data.data.aa) : null;
        //         }
        //     });
        // },
        // getConsentMedicalReports () {
        //     this.axios.get('Profile/GetConsent', {
        //         'params': {
        //             'consentType': 1002
        //         }
        //     }).then(({ data }) => {
        //         if (data.data) {
        //             this.consent.medicalReports = data.data.ia;
        //             this.consent.medicalReportsLastUpdated = data.data.aa ? convertToUserReadableDateTime(data.data.aa) : null;
        //         }
        //     });
        // },
        // updateConsentConsultations () {
        //     this.consent.submitMessage = 'Updating your preference. Please wait...';
        //     this.$refs.popupUpdateSuccessful.show();

        //     this.axios.post('Profile/UpdateConsent', {
        //         'ct': 1001,
        //         'ia': this.consent.pastConsultation
        //     }).then(({ data }) => {
        //         this.consent.submitMessage = 'Permission updated successfully!';

        //         if (data.data) {
        //             this.consent.pastConsultation = data.data.ia;
        //             this.consent.pastConsultationLastUpdated = data.data.aa ? convertToUserReadableDateTime(data.data.aa) : null;
        //         }
        //     }).catch(() => {
        //         this.consent.submitMessage = 'Error updating your preference. Please try again.';
        //         this.getConsentConsultations();
        //     });
        // },
        // updateConsentMedicalReports () {
        //     this.consent.submitMessage = 'Updating your preference. Please wait...';
        //     this.$refs.popupUpdateSuccessful.show();

        //     this.axios.post('Profile/UpdateConsent', {
        //         'ct': 1002,
        //         'ia': this.consent.medicalReports
        //     }).then(({ data }) => {
        //         this.consent.submitMessage = 'Permission updated successfully!';
        //         if (data.data) {
        //             this.consent.medicalReports = data.data.ia;
        //             this.consent.medicalReportsLastUpdated = data.data.aa ? convertToUserReadableDateTime(data.data.aa) : null;
        //         }
        //     }).catch(() => {
        //         this.consent.submitMessage = 'Error updating your preference. Please try again.';
        //         this.getConsentMedicalReports();
        //     });
        // },
        // dismissPopupSuccessful () {
        //     this.$refs.popupUpdateSuccessful.hide();
        // },
        getKycStatus () {
            this.axios.get('UserDependent/GetKycStatus')
                .then(({ data }) => {
                    let result = data.data;
                    this.kycStatus = result.s;
                });
        },
        dismissPopupCompleteProfile () {
            this.$refs.popupCompleteProfile.hide();
        },
        scrollToAnchorPoint (refName) {
            const el = this.$refs[refName];
            el.$el.scrollIntoView({ 'behavior': 'smooth' });
        }
    }
};

</script>

<style>

</style>
